module.exports = __webpack_public_path__ + "static/media/increase-size.7086584b.svg";